<template>
    <div class="main-div">
        <el-row justify="end" class="headbar">
            <el-col :span="4" />
            <el-col :span="20">
                <el-form
                    :model="args"
                    class="search-form" :inline="true">
                    <el-form-item label="" prop="corp" style="width: 150px;">
                        <el-select
                            ref="corpSelect"
                            v-model="args.corp"
                            autocomplete="off"
                            placeholder="企业"
                            clearable
                            @change="load_users">
                            <el-option
                                v-for="(corp_data, i) in corp_list"
                                :key="i"
                                :label="corp_data.name"
                                :value="corp_data.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="query" style="width: 250px;">
                        <el-input
                            v-model="args.query"
                            autocomplete="off"
                            placeholder=""
                            clearable
                            maxlength="32"
                            @change="load_users" />
                    </el-form-item>
                    <el-form-item style="width: 46px;">
                        <el-button
                            type="primary"
                            @click="load_users">
                            <el-icon><Search /></el-icon>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="content">
            <el-table
                ref="elTable"
                :data="user_list.slice((page-1)*rspp,page*rspp)"
                :highlight-current-row="true"
                :border="true"
                :row-key="row => row.id"
                :expand-row-keys="expand_row_keys"
                @expand-change="on_expand_change">
                <el-table-column fixed type="index" align="center" />
                <el-table-column
                    v-for="(col, i) in tableCols"
                    :key="i"
                    :fixed="!i"
                    :label="col.label"
                    v-bind="col"
                    header-align="center"
                    :align="col.align" />
                <el-table-column />
                <el-table-column fixed="right" label="" width="110" align="center">
                    <template #header>
                        <el-tooltip content="添加" placement="top">
                            <el-button
                                link
                                type="primary"
                                @click="add_user()">
                                <el-icon><plus /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                    <template #default="item">
                        <el-tooltip content="切换" placement="top">
                            <el-button
                                link
                                type="success"
                                size="large"
                                @click="switch_user($event, item.row)">
                                <el-icon><SwitchFilled /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="编辑" placement="top">
                            <el-button
                                link
                                type="primary"
                                size="large"
                                @click="mod_user($event, item.row)">
                                <el-icon><edit /></el-icon>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                            <el-button
                                link
                                type="danger"
                                size="small"
                                @click="del_user($event, item.row)">
                                <el-icon><delete /></el-icon>
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row class="pagebar">
            <el-pagination
                align="center"
                :current-page="page"
                :page-sizes="[10,20,50,999]"
                :page-size="rspp"
                layout="total, sizes, prev, pager, next, jumper"
                :total="user_list.length"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </el-row>
    </div>
    <DialogUser ref="DialogUser" />
</template>
<script>
import {notify} from '../../assets/js/utils.js';
import {try_catch} from '../../assets/js/async.js';
import {Search, Edit, Plus, Delete, SwitchFilled} from '@element-plus/icons-vue';
import DialogUser from './dlg-user.vue';
import UserStore from '../../stores/user.js';

export default {
    name: 'UserList',
    components: {
        Search,
        Edit,
        Plus,
        Delete,
        DialogUser,
        SwitchFilled,
    },
    data: function() {
        return {
            args: {
                corp: '',
                query: '',
            },
            expand_row_keys: [],
            user_list: [],
            corp_list: null,
            page: 1, // 当前页码
            rspp: 20, // 每页的数据条数
        };
    },
    computed: {
        userstore() {
            return UserStore();
        },
        tableCols() {
            return [
                {prop: 'username', label: '账号', width: 150, align: 'center'},
                {prop: 'email', label: '邮箱', width: 250, align: 'center'},
                {prop: 'us_phone_number', label: '电话', width: 150, align: 'center'},
                {
                    prop: 'roles',
                    label: '角色',
                    width: 100,
                    align: 'center',
                },
                {
                    prop: 'corporation.name',
                    label: '企业',
                    width: 150,
                    align: 'center',
                },
                {
                    prop: 'state_name',
                    label: '状态',
                    width: 80,
                    align: 'center',
                },
                {
                    prop: 'create_datetime',
                    label: '创建时间',
                    width: '160',
                    align: 'center',
                },
            ];
        },
    },
    beforeMount() {
        this.load_users();
    },
    methods: {
        // on_expand_change(row, _children) {
        on_expand_change(row) {
            const key = row.id;
            const index = this.expand_row_keys.indexOf(key);
            if (index < 0) {
                this.expand_row_keys.push(key);
            } else {
                this.expand_row_keys.splice(index, 1);
            }
        },
        async add_user() {
            return await try_catch(async () => {
                const data = await this.$refs.DialogUser.show({
                    data: {
                        corp_code: this.corp_list.find(x => x.id === this.args.corp)?.code,
                        roles: ['user'],
                        active: true,
                    },
                    list: this.user_list,
                    corporations: this.corp_list,
                });
                console.debug(data);
                this.load_users();
            });
        },
        async mod_user(_, row) {
            return await try_catch(async () => {
                const data = await this.$refs.DialogUser.show({
                    data: JSON.parse(JSON.stringify(row)),
                    list: this.user_list,
                    corporations: this.corp_list,
                });
                console.debug(data);
                this.load_users();
            });
        },
        async del_user(_, row) {
            if (row.id === this.userstore.user.id) {
                notify('warning', '不能删除当前登录用户.');
                return;
            }
            return await try_catch(async () => {
                await this.$confirm('是否确认删除该账号', '删除提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });
                const url = `/admin/api/users/${row.id}`;
                const res = await this.axios.delete(url);
                if (res.data?.result) {
                    notify('success', '删除成功');
                } else {
                    notify('error', res.data.error);
                }
                this.load_users();
            });
        },
        async switch_user(_, row) {
            return await try_catch(async () => {
                const username = row.username;
                await this.$confirm(`是否要切换到此账号“${username}”`, '切换提示', {
                    iconClass: 'el-icon-question', // 自定义图标样式
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning', // 提示类型  success/info/warning/error
                });
                const msg = await this.userstore.switch(username);
                if (msg) {
                    notify('error', msg);
                } else {
                    notify('success', `已切换到帐号“${username}”`);
                    this.$router.push('/');
                }
            });
        },
        async load_users() {
            await try_catch(async () => {
                const url = `/admin/api/users/`;
                const args = [['q', this.args.query], ['c', this.args.corp]].reduce((rs, [k, v]) => {
                    if (v) rs[k] = v;
                    return rs;
                }, {});
                const [corp_list, res] = await Promise.all([
                    this.load_corps(),
                    this.axios.get(url, {params: args})]);
                if (res.data.code && res.data.code !== 200) {
                    notify('error', `加载用户列表失败 ${res.data.code}`);
                    console.error(res);
                    return;
                }
                const user_list = res.data.data;
                console.log(res, res.data);
                user_list.forEach(user => {
                    user.roles = user.roles?.map(role => role.name) || [];
                    user.create_datetime = user.create_datetime.replace('T', ' ');
                    user.state_name = user.active && '活跃' || '冻结';
                    user.corp_name = corp_list.find(corp => corp.id === user.corp_id)?.name;
                    user.corp_code = corp_list.find(corp => corp.id === user.corp_id)?.code;
                });
                this.user_list.length = 0;
                this.user_list.push(...user_list);
            });
        },
        async load_corps() {
            if (!this.corp_list) {
                const url = `/admin/api/corporations/`;
                const res = await this.axios.get(url);
                this.corp_list = res.data.data;
            }
            return this.corp_list;
        },
        handleSizeChange(val) {
            this.page = 1;
            this.rspp = val;
        },
        // 当前页改变时触发 跳转其他页
        handleCurrentChange(val) {
            this.page = val;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div{
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: column;
}
.headbar {
}
.footbar {
}
.content {
    height: 100px;
    flex-grow: 1;
}
.search-form {
    text-align: right;
}
.search-form>.el-form-item {
    margin-bottom: 0;
    margin-right: 0;
    width: 150px;
}
</style>
